import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 5.333a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334M6.667 8a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.666 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.93 7.701a.67.67 0 0 1 0 .597L15.333 8c.597.298.596.299.596.3l-.003.005-.008.015-.026.052-.101.184a13.783 13.783 0 0 1-1.888 2.567C12.597 12.516 10.6 14 8 14s-4.597-1.484-5.903-2.877A13.8 13.8 0 0 1 .209 8.556a8 8 0 0 1-.127-.236l-.008-.015-.002-.004-.002-.003L.667 8l-.597.298a.67.67 0 0 1 0-.596L.667 8C.07 7.702.07 7.701.07 7.7l.003-.005.008-.015a5 5 0 0 1 .127-.236 13.783 13.783 0 0 1 1.888-2.567C3.403 3.484 5.4 2 8 2s4.597 1.484 5.903 2.877a13.8 13.8 0 0 1 1.888 2.567 8 8 0 0 1 .127.236l.008.015.002.004zm-14.214.77A11 11 0 0 1 1.427 8q.11-.191.29-.472A12.5 12.5 0 0 1 3.07 5.79C4.264 4.516 5.933 3.333 8 3.333s3.736 1.183 4.93 2.456A12.5 12.5 0 0 1 14.573 8q-.11.191-.29.472a12.5 12.5 0 0 1-1.353 1.739c-1.194 1.273-2.863 2.456-4.93 2.456s-3.736-1.183-4.93-2.456a12.5 12.5 0 0 1-1.354-1.74M15.333 8c.597-.298.597-.298.596-.299z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })